var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visitor-index"},[_c('div',{staticClass:"home-body"},[_c('Media'),_c('Service')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }